import React from 'react';
import { Target, Award, CheckCircle, TrendingUp, DollarSign, LifeBuoy, GraduationCap, Users } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  Target,
  Award,
  CheckCircle,
  TrendingUp,
  DollarSign,
  LifeBuoy,
  GraduationCap,
  Users
};

const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 to-cyan-50/30">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-teal-600">CRS Tech</span>
          </h2>
          <p className="text-xl text-gray-600">
            We're not just another IT company. We're your strategic partner in digital transformation.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div
                key={benefit.id}
                className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100 group"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>

        {/* Showcase Statement */}
        <div className="mt-16 bg-white rounded-3xl p-12 shadow-xl border-2 border-cyan-200">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              If we can build this amazing website for ourselves...
            </h3>
            <p className="text-xl text-gray-600 mb-6">
              Imagine what we'll create for your business. This website is a testament to our capabilities - modern design, seamless functionality, and attention to every detail.
            </p>
            <p className="text-lg text-cyan-600 font-semibold">
              Your website will be equally impressive, if not more!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;